import * as rmd from 'material-ui';
import React from 'react';
import config from 'cfg';

import _ from 'lodash';
import Promise from 'bluebird';

class RoundPicker extends React.Component {
    constructor(props, context) {
        super(props, context);

        let key = props.propKey || 'round';
        let value = +props[key] || null;

        this.state = {
            rounds: [],
            tournamentId: props.tournamentId,
            seasonId: props.seasonId,
            round: value
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentWillReceiveProps(nextProps) {
        // super.componentWillReceiveProps(nextProps)
        let { tournamentId, seasonId } = nextProps;
        if (nextProps !== this.props.tournamentId || nextProps !== this.props.seasonId) {
            this.setState({ tournamentId, seasonId }, () => {
                this.loadData();
            });
        }
    }

    shouldComponentUpdate() {
        return true;
    }

    loadData() {
        let { tournamentId, seasonId } = this.state;
        if (!tournamentId) return;

        return Promise.props({
            tournamentId,
            seasonId:
                seasonId ||
                fetch(`${config.apis.ss2}/tournaments/${tournamentId}`)
                    .then(response => response.json())
                    .then(t => {
                        return (t.currentSeason && t.currentSeason.id) || _.last(t.seasons).id;
                    })
        })
            .then(res => {
                return fetch(`${config.apis.ss2}/tournaments/${res.tournamentId}/season?seasonId=${res.seasonId}`)
                    .then(response => response.json())
                    .then(s => s.season.stages[0].roundsList)
                    .catch(e => []);
            })
            .then(rounds => {
                let state = { rounds };

                // default value = max round
                if (this.props.options && this.props.options.defaultMaxRound && !this.state.round) {
                    let round = _.last(rounds).name;
                    state.round = +round;
                }
                this.setState(state);
            });
    }

    renderOption(option) {
        return <rmd.MenuItem key={option.value} value={option.value} primaryText={option.text} />;
    }

    handleRoundChange = (e, k, val) => {
        let key = this.props.propKey || 'round';
        let round = +val;
        this.props.onChange(key, round);
        this.setState({ round });
    };

    render() {
        var rounds = _.chain(this.state.rounds || [])
            .map(c => ({ text: 'Round ' + c.name, value: +c.name }))
            .value();

        return (
            <div>
                <rmd.SelectField
                    floatingLabelText={this.props.label || 'Round'}
                    floatingLabelFixed={rounds.length > 0}
                    value={this.state.round}
                    disabled={rounds.length === 0}
                    onChange={this.handleRoundChange}
                >
                    {this.renderOption({ text: 'Current', value: null, key: 'current' })}
                    {rounds.map(this.renderOption)}
                </rmd.SelectField>
            </div>
        );
    }
}

export default RoundPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/RoundPicker.js
 **/